// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ShopArticleTaxListResultModel from '../../model/shop-article-tax-list-result-model';
import ShopArticleTaxListResultDTO from '../dto/shop-article-tax-list-result-dto';
import dtoSchema from '../schemas/shop-article-tax-list-result-schema';
import ShopArticleTaxModel from '../../model/shop-article-tax-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class ShopArticleTaxListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ShopArticleTaxListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ShopArticleTaxModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: ShopArticleTaxModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<ShopArticleTaxListResultDTO>): ShopArticleTaxListResultModel;
  static toModel(dto: DeepPartial<ShopArticleTaxListResultDTO> | undefined | null): ShopArticleTaxListResultModel | undefined;
  static toModel(dto: DeepPartial<ShopArticleTaxListResultDTO> | undefined | null): ShopArticleTaxListResultModel | undefined {
    return dto ? new ShopArticleTaxListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ShopArticleTaxListResultModel> | ShopArticleTaxListResultModel): ShopArticleTaxListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as ShopArticleTaxListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ShopArticleTaxListResultModel, can not map to ShopArticleTaxListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
